import React, { FunctionComponent } from 'react';
import { ImageLinkModel } from '../../models/navigationItem.model';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import CustomExternalAnchor from '../../../@shared/customExternalAnchor';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import useEEActive from '../../../../hooks/useEEActive';
import { googleNavClickEvent } from '../../../../utils/analytics';
import { topMainMenu } from '../../../../constants/analytics.constants';

const ImageLink: FunctionComponent<{ model: ImageLinkModel; onClick?: () => void }> = ({ model, onClick }) => {
  const isEE = useEEActive();
  if (isEE) {
    // allow easier editing on Experience editor
    return (
      <div className="navigation-link navigation-link--image">
        <span className="navigation-link__image-wrapper">
          <Image field={model.image} className="navigation-link__image" />
        </span>
        <span className="navigation-link__text-wrapper">
          <CustomExternalAnchor field={model.link} className="navigation-link__text" />
        </span>
      </div>
    );
  }
  return (
    <>
      {model.link.value.title && (
        <RoutableSitecoreLink
          field={model.link}
          className={`navigation-link navigation-link--image ${
            model?.hideOnMobile !== false ? 'navigation-link--image__hide-on-mobile' : ''
          }`}
          onClick={() => {
            onClick && onClick();
            googleNavClickEvent(topMainMenu, model?.link?.value?.href, model.linkText);
          }}
        >
          {model.image && (
            <span className="navigation-link__image-wrapper">
              <Image field={model.image} className="navigation-link__image" />
            </span>
          )}
          {model.linkText && (
            <span className="navigation-link__text-wrapper">
              <span className="navigation-link__text">{model.linkText}</span>
              <span className="navigation-link__underline" />
            </span>
          )}
        </RoutableSitecoreLink>
      )}
    </>
  );
};

export default ImageLink;
